import React from 'react';
import RenderRoute from '../components/renderauth'
import {theme} from '../theme'

function Auth() {
  const {colors} = theme
  return (
    <div className="App">
      <header className="App-header" >
        <h1  style = {{verticalAlign: 'middle', color: colors.light}}>AutoHACCP</h1>
        <RenderRoute />
      </header>
    </div>
  );
}

export default Auth;
